module.exports={
  "personas-sin-vivienda": {
    "color": "",
    "background": "",
    "label": "Vivienda y personas sin hogar",
    "date": "5-3-2022"
  },
  "policia": {
    "color": "",
    "background": "",
    "label": "Policía",
    "date": "5-3-2022"
  },
  "clima": {
    "color": "",
    "background": "",
    "label": "Emergencia Climática",
    "date": "5-3-2022"
  },
  "economia": {
    "color": "",
    "background": "",
    "label": "Igualdad económica y vivienda",
    "date": "10-12-2022"
  }
}